var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c("el-breadcrumb-item", [_vm._v("基地生产数据")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.baseId,
                        expression: "baseId",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "farmTitle",
                  width: "100",
                  align: "center",
                  label: "基地名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "100",
                  align: "center",
                  label: "种植位置",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.areaTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "亩数/总亩数",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.measureTotal))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "80",
                  align: "center",
                  label: "品种",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.categoryTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "80",
                  align: "center",
                  label: "品名",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "定植时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("formatDate")(item.plantTime))
                                ),
                              ]),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "180",
                  align: "center",
                  label: "供应开始时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(item.supplypStarTime)
                                  )
                                ),
                              ]),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "180",
                  align: "center",
                  label: "供应结束时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(item.supplypEndTime)
                                  )
                                ),
                              ]),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "120",
                  align: "center",
                  label: "供应次数",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.supplyTimes))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "180",
                  align: "center",
                  label: "次供应产量(斤)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(item.supplyTimesProduce)),
                              ]),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "总产量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.totalProduce))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "亩产" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.measureProduce))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "审核状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              item.reviewStatus === 0
                                ? _c("span", [_vm._v("通过")])
                                : _vm._e(),
                              item.reviewStatus === -1
                                ? _c("span", [_vm._v("未通过")])
                                : _vm._e(),
                              item.reviewStatus === 1
                                ? _c("span", [_vm._v("待审核")])
                                : _vm._e(),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "120", align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              !_vm.baseId
                                ? _c(
                                    "div",
                                    [
                                      item.reviewStatus === 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openAuditDialog(
                                                    item.farmProdutionId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 审核 ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editItem(
                                                scope.row.farmId,
                                                scope.row.farmTitle,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 编辑 ")]
                                      ),
                                      _c(
                                        "confirm-button",
                                        {
                                          staticStyle: { margin: "0 10px" },
                                          attrs: {
                                            size: "small",
                                            type: "text",
                                            title: "确认要删除该条数据？",
                                          },
                                          on: {
                                            confirmed: function ($event) {
                                              return _vm.deleteItem(
                                                item.farmProdutionId
                                              )
                                            },
                                          },
                                        },
                                        [_c("span", [_vm._v("删除")])]
                                      ),
                                    ],
                                    1
                                  ),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核 ：", prop: "reviewStatus" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择审核是否通过",
                          },
                          model: {
                            value: _vm.itemParams.reviewStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "reviewStatus", $$v)
                            },
                            expression: "itemParams.reviewStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 0, label: "通过" },
                          }),
                          _c("el-option", {
                            attrs: { value: -1, label: "拒绝" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.auditItem },
                        },
                        [_vm._v(" 确 认 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: "编辑基地",
            visible: _vm.editVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
            close: _vm.resetEditForm,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.editLoading,
                  expression: "editLoading",
                },
              ],
            },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: {
                    model: _vm.editParams,
                    rules: _vm.checkEditParams,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "基地名称 ：", prop: "farmTitle" } },
                    [_c("span", [_vm._v(_vm._s(_vm.editParams.farmTitle))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "种植位置 ：", prop: "areaId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择种植位置",
                          },
                          model: {
                            value: _vm.editParams.areaId,
                            callback: function ($$v) {
                              _vm.$set(_vm.editParams, "areaId", $$v)
                            },
                            expression: "editParams.areaId",
                          },
                        },
                        _vm._l(_vm.farmAreaList, function (item) {
                          return _c("el-option", {
                            key: item.areaId,
                            attrs: {
                              value: item.areaId,
                              label: item.areaTitle,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "亩数/总亩数 ：", prop: "measureTotal" },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.editParams.measureTotal))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品种 ：", prop: "categoryId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", placeholder: "请选择品种" },
                          model: {
                            value: _vm.editParams.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.editParams, "categoryId", $$v)
                            },
                            expression: "editParams.categoryId",
                          },
                        },
                        _vm._l(_vm.farmCategoryList, function (item) {
                          return _c("el-option", {
                            key: item.categoryId,
                            attrs: {
                              value: item.categoryId,
                              label: item.categoryTitle,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "品名 ：", prop: "goodTitle" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入品名" },
                        model: {
                          value: _vm.editParams.goodTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.editParams, "goodTitle", $$v)
                          },
                          expression: "editParams.goodTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("date-components", {
                    attrs: {
                      "start-prop": "plantTime",
                      "start-date": _vm.editParams.plantTime,
                      "date-type": "date",
                      "date-width": "100%",
                      "show-type": "left",
                      "label-name": "定植时间：",
                    },
                    on: { "set-start-date": _vm.getStartDate },
                  }),
                  _c("date-components", {
                    attrs: {
                      "start-prop": "supplypStarTime",
                      "start-date": _vm.editParams.supplypStarTime,
                      "date-type": "date",
                      "date-width": "100%",
                      "show-type": "left",
                      "label-name": "供应开始时间：",
                    },
                    on: { "set-start-date": _vm.getStartDate },
                  }),
                  _c("date-components", {
                    attrs: {
                      "start-prop": "supplypEndTime",
                      "start-date": _vm.editParams.supplypEndTime,
                      "date-type": "date",
                      "date-width": "100%",
                      "show-type": "left",
                      "label-name": "供应结束时间：",
                    },
                    on: { "set-start-date": _vm.getStartDate },
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应次数 ：", prop: "supplyTimes" } },
                    [_c("span", [_vm._v(_vm._s(_vm.editParams.supplyTimes))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "每次供应产量(斤) ：",
                        prop: "totalProduce",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入每次供应产量(斤)",
                        },
                        model: {
                          value: _vm.editParams.totalProduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.editParams, "totalProduce", $$v)
                          },
                          expression: "editParams.totalProduce",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总产量(斤) ：", prop: "totalProduce" } },
                    [_c("span", [_vm._v(_vm._s(_vm.editParams.totalProduce))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "亩产量(斤) ：", prop: "measureProduce" },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.editParams.measureProduce)),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            disabled: _vm.editDisabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveEdit("editForm")
                            },
                          },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.editVisible = false
                            },
                          },
                        },
                        [_vm._v(" 返 回 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }